import React from 'react';
import valueChangeValidator from "hoc/valueChangeValidator";
import SiteIdDropdown from 'pages/UserManagement/UserSearchPanel/SiteIdDropdown';
import GroupDropdown from 'pages/UserManagement/CreateUserModal/GroupDropdown';
import RetailerDropdown from 'pages/Rewards/RetailerItemModal/RetailerDropdown';
import NgcEndpointDropdown from 'pages/Rewards/RetailerItemModal/NgcEndpointDropdown';
import ReceiptItemImagePicker from 'pages/Receipt/ReceiptItemImagePicker';
import RetailerItemCurrencyInput from 'pages/Rewards/RetailerItemModal/RetailerItemCurrencyInput';
import RetailerItemImagePicker from 'pages/Rewards/RetailerItemModal/RetailerItemImagePicker';
import {
    Checkbox,
    ContentEditableInput,
    CurrencyInput,
    DateTimePicker,
    DropdownInput,
    NumericInput,
    Radio,
    TextArea,
    TextInput
} from "components/forms/BasicFormFields/index";
import LangRadioOptions from "../CustomFields/LangRadioOptions";
import AvailableStepsCheckboxOptions from "../CustomFields/AvailableStepsCheckboxOptions";
import HomepageItemOptions from "../CustomFields/HomepageItemOptions";
import ResourceDropdown from "components/forms/CustomFields/ResourceDropdown";
import ReceiptCampaignDropdown from "components/forms/CustomFields/ReceiptCampaignDropdown";

const components = {
    'text': valueChangeValidator(TextInput),
    'textarea': TextArea,
    'radio': Radio,
    'checkbox': Checkbox,
    'currency': CurrencyInput,
    'contenteditable': ContentEditableInput,
    'dropdown': DropdownInput,
    'number': NumericInput,
    'date': DateTimePicker,

    // custom components
    'retailerItemImagePicker': RetailerItemImagePicker,
    'receiptItemImagePicker': ReceiptItemImagePicker,
    'retailerItemCurrency': valueChangeValidator(RetailerItemCurrencyInput),
    'retailerDropdown': RetailerDropdown,
    'ngcEndpointDropdown': NgcEndpointDropdown,
    'siteIdDropdown': SiteIdDropdown,
    'groupDropdown': GroupDropdown,
    'langRadioOptions': LangRadioOptions,
    'availableStepOptions': AvailableStepsCheckboxOptions,
    'homepageItemOptions': HomepageItemOptions,
    'resourceDropdown': ResourceDropdown,
    'receiptCampaignDropdown': ReceiptCampaignDropdown,
};

export default components;



// WEBPACK FOOTER //
// ./public/components/forms/Component Sets/BasicFormComponents.jsx